import { topics } from "@/mocks/home";

type TopicWallProps = {
  onNotify: (message: string) => void;
};

export default function TopicWall({ onNotify }: TopicWallProps) {
  return (
    <section id="topics" className="w-full bg-background-100 px-4 py-16 md:px-6 md:py-24">
      <div className="mx-auto w-full max-w-6xl">
        <div className="flex flex-col gap-4 md:flex-row md:items-end md:justify-between">
          <div className="max-w-xl">
            <span className="font-label text-xs tracking-[0.3em] text-secondary-700">TOPIC WALL</span>
            <h2 className="mt-3 font-heading text-2xl font-bold text-foreground-950 md:text-4xl">
              话题墙
            </h2>
            <p className="mt-4 text-sm leading-relaxed text-foreground-600 md:text-base">
              按讨论热度聚合的话题入口，点选任意标签即可浏览相关合集与热帖，热度越靠前越值得先看。
            </p>
          </div>
          <span className="flex items-center gap-2 self-start rounded-full bg-secondary-100 px-4 py-2 text-xs font-medium text-secondary-900 md:self-auto">
            <i className="ri-price-tag-3-line text-base"></i>
            共 {topics.length} 个话题
          </span>
        </div>

        <div className="mt-10 flex flex-wrap gap-3 md:mt-14 md:gap-4">
          {topics.map((topic) => {
            const base =
              "group flex cursor-pointer items-center gap-2 rounded-full border px-4 py-2.5 text-sm transition-all duration-200 md:px-5 md:py-3";
            const skin = topic.hot
              ? "border-primary-200 bg-primary-500 text-background-50 hover:bg-primary-600"
              : "border-background-300 bg-background-50 text-foreground-800 hover:border-primary-300 hover:text-primary-700";
            return (
              <button
                key={topic.name}
                type="button"
                onClick={() => onNotify(`已按「${topic.name}」筛选相关话题`)}
                className={`${base} ${skin}`}
              >
                <span className="whitespace-nowrap font-medium">{topic.name}</span>
                <span
                  className={`whitespace-nowrap font-label text-xs ${
                    topic.hot ? "text-background-200" : "text-foreground-500"
                  }`}
                >
                  {topic.heat.toLocaleString()}
                </span>
                {topic.hot && <i className="ri-fire-line text-sm"></i>}
              </button>
            );
          })}
        </div>
      </div>
    </section>
  );
}